import React, { Fragment, useState, useEffect, useRef } from "react";
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faShoppingCart, faWallet, faCalendar, faPlus } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import Header from './Header';
import AddTopUp from './AddTopUp';
import AlertService from '../../../components/Alerts/alerts';
import DashboardService from "../dashboard.service";
import AuthService from "../../Authentication/auth.service";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import Alerts from "../../../components/Alerts/alerts";

const CreditPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [branch, setBranch] = useState('');
  const [balance, setBalance] = useState(0);
  const [transactions, setTransactions] = useState([]);
  const [showTopUp, setShowTopUp] = useState(false);
  const [loading, setLoading] = useState(true);

  const handleTopUpClick = () => {
    setShowTopUp(true);
  };

  const handleCloseTopUp = () => {
    setShowTopUp(false);
  };

  useEffect(() => {
    fetchTopups()
    // Simulated transaction data - replace with actual API call
   
    setTransactions([]);
  }, []);

  const fetchTopups = () => {
    const userString = localStorage.getItem('user');
    const user = JSON.parse(userString);
    const userId = user['_id'];
    let data = {
      user_id: userId,
    }
    setLoading(true);
    DashboardService.GetTopUp(data).then((response) => {
      setLoading(false);
      if (response.data.message === "Unauthorized") {
        AuthService.logout();
        navigate("/login");
        window.location.reload();
      } else {
        let top_ups = response.data.data
        setTransactions(top_ups);
        setBalance(response.data.total)
      }
    }).catch((error) => {
      setLoading(false);
      const errContent = (error.response && error.response.data) || error.message || error.toString();
      if (errContent) {
        Alerts.swalErrorAlert(errContent);
      } else {
        Alerts.swalErrorAlert(t("Server Error, Please try again later."));
      }
    });
  };


  const styles = {
    creditPage: {
      fontFamily: 'Arial, sans-serif',
      width: '100%',
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '20px',
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '20px',
    },
    balanceSection: {
      background: 'linear-gradient(to bottom, #4a4a4a, #000000)',
      color: 'white',
      padding: '20px',
      borderRadius: '10px',
      textAlign: 'center',
    },
    walletIcon: {
      backgroundColor: '#f0e68c',
      width: '50px',
      height: '50px',
      borderRadius: '50%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      margin: '0 auto 10px',
    },
    transactionsSection: {
      backgroundColor: '#f8f9fa',
      borderRadius: '10px',
      padding: '20px',
      marginTop: '20px',
    },
    topUp: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '20px',
    },
    topUpButton: {
      backgroundColor: '#000',
      color: 'white',
      border: 'none',
      borderRadius: '50%',
      width: '30px',
      height: '30px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
    },
    filterDate: {
      position: 'relative',
      marginBottom: '20px',
    },
    filterInput: {
      width: '100%',
      padding: '10px',
      paddingRight: '30px',
      border: '1px solid #ccc',
      borderRadius: '5px',
    },
    calendarIcon: {
      position: 'absolute',
      right: '10px',
      top: '50%',
      transform: 'translateY(-50%)',
    },
    transactionsList: {
      listStyleType: 'none',
      padding: 0,
    },
    transactionItem: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '10px 0',
      borderBottom: '1px solid #eee',
    },
    transactionInfo: {
      display: 'flex',
      flexDirection: 'column',
    },
    transactionType: {
      fontWeight: 'bold',
    },
    transactionDate: {
      color: '#666',
      fontSize: '0.9em',
    },
    transactionAmount: {
      fontWeight: 'bold',
    },
  };

  return (
    <Fragment>
      <div className="app-main__outer">
        <div className="app-main__inner">
          <TransitionGroup>
            <CSSTransition component="div" classNames="TabsAnimation"
              appear={true} timeout={0} enter={false} exit={false}>
              <div>
                <div className="app-page-title">
                  <div className="page-title-wrapper">
                    <Header branch={branch} setBranch={setBranch} />
                  </div>
                </div>
                <div>

                  <header style={styles.header}>
                    {/* <FontAwesomeIcon icon={faBars} /> */}
                    <h1></h1>
                    <h1>My Credit</h1>
                    <h1></h1>
                    {/* <FontAwesomeIcon icon={faShoppingCart} /> */}
                  </header>

                  <div style={styles.balanceSection}>
                    <div style={styles.walletIcon}>
                      <FontAwesomeIcon icon={faWallet} />
                    </div>
                    <p>Balance</p>
                    <h2>{parseFloat(balance).toFixed(2)}</h2>
                  </div>

                  <div style={styles.transactionsSection}>
                    <div style={styles.topUp}>
                      <span>Top-up now</span>
                      <button style={styles.topUpButton} onClick={handleTopUpClick}>
                        <FontAwesomeIcon icon={faPlus} />
                      </button>
                    </div>

                    <h3>Transactions History</h3>

                    {/* <div style={styles.filterDate}>
                      <input type="text" placeholder="Filter Date" style={styles.filterInput} />
                      <FontAwesomeIcon icon={faCalendar} style={styles.calendarIcon} />
                    </div> */}

                    <ul style={styles.transactionsList}>
                      {transactions.map((transaction, index) => (
                        <li key={index} style={styles.transactionItem}>
                          <div style={styles.transactionInfo}>
                            <span style={styles.transactionType}>{transaction.type}</span>
                            <span style={styles.transactionDate}>{moment(transaction.date, 'YYYY-MM-DD HH:mm:ss').format('DD MMM, YYYY - HH:mm A')}</span>


                          </div>
                          <span style={{
                            ...styles.transactionAmount,
                            color: transaction.type === 'Topup' || transaction.type === 'Reward' || transaction.type === 'Order Cancelled' 
                              ? 'green' 
                              : 'red'
                          }}>
                            {transaction.type === 'Topup' || transaction.type === 'Reward' || transaction.type === 'Order Cancelled'
                              ? '+' 
                              : '-'}
                            {parseFloat(Math.abs(transaction?.amount)).toFixed(2)}
                            {transaction.type === 'Topup' || transaction.type === 'Reward' || transaction.type === 'Order Cancelled'
                              ? '↑' 
                              : '↓'}
                          </span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

              </div>
            </CSSTransition>
          </TransitionGroup>
        </div>
      </div>
      {showTopUp && <AddTopUp onClose={handleCloseTopUp} />}
    </Fragment>
  );
};

export default CreditPage;